<template>
  <div class="IntervalIOReport">
    <box :title="$t('search')">
      <div class="pa-2">
        <DailyDatePicker @getDate="getDate" />
      </div>
    </box>

    <box :title="$t('IntervalIOReportList')" class="mt-2">
      <div v-if="list.length > 0">
        <v-alert
          class="ma-2"
          text
          dense
          color="primary lighten-1"
          icon="mdi-comment-alert-outline"
          border="left"
        >
          با کلیک راست کردن روی هر سطر می توانید عملیات ثبت مرخصی، ماموریت،ورود
          و خروج و اضافه کار را انجام دهید
        </v-alert>
        <IntervalIOReportListWeb :list="list" class="hidden-sm-and-down" />
        <IntervalIOReportListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import IntervalIOReportListMob from "../../components/io/IntervalIOReport/IntervalIOReportListMob.vue";
import IntervalIOReportListWeb from "../../components/io/IntervalIOReport/IntervalIOReportListWeb.vue";
export default {
  components: { IntervalIOReportListWeb, IntervalIOReportListMob },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    
    getDate(BeginDate, endDate) {
      this.GetPersonMergeIo(BeginDate, endDate);
      //debugger
    },
    GetPersonMergeIo(BeginDate, endDate) {
      //debugger
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", endDate);
      var perno = this.$store.state.personel.personelDetail.Perno;
      params.append("perno", perno);

      this.$store.dispatch("GetPersonMergeIo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          this.list = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>